"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../../shared/core");
var IconHeader_1 = require("../../../../../../../shared/core/components/IconHeader");
var VisualAccessible_1 = require("../../../../../../../shared/core/components/VisualAccessible");
var DownloadButton_1 = require("../../../../../components/DownloadButton");
var copy_1 = require("../../../../../copy");
var date_1 = require("../../../../../utils/date");
var handle_bill_download_1 = require("../../../../../utils/handle-bill-download");
var ProgressBar_1 = require("../ProgressBar");
var Header_styled_1 = require("./Header.styled");
var Header = function (_a) {
    var isStatementAvailable = _a.isStatementAvailable, totalCharge = _a.totalCharge, start = _a.start, end = _a.end, _b = _a.isCurrentPeriod, isCurrentPeriod = _b === void 0 ? false : _b, accountId = _a.accountId;
    var _c = (0, core_1.useComponents)(), TextLink = _c.TextLink, Icon = _c.Icon, Stack = _c.Stack, Badge = _c.Badge, Callout = _c.Callout;
    var _d = (0, date_1.formatHeadingDateRange)(start, end), startDate = _d.startDate, endDate = _d.endDate;
    var _e = (0, core_1.useCopy)(copy_1.defaultOptions), Copy = _e.Copy, copy = _e.copy;
    var _f = (0, core_1.useLinks)(), billingHistory = _f.billingHistory, billingStatementDownload = _f.billingStatementDownload;
    var dateFormat = 'yyyy-MM-dd';
    var from = (0, date_1.formatDate)(start, dateFormat);
    var to = (0, date_1.formatDate)(end, dateFormat);
    var title = copy('billingDetailsTitleV2', { startDate: startDate, endDate: endDate });
    var subtitle = copy('billingDetailsSubtitle');
    return (react_1.default.createElement(Stack, { spaceBetween: [4, 8], "data-testid": "billing-period" },
        react_1.default.createElement(TextLink, { "data-testid": "back", href: billingHistory() },
            react_1.default.createElement(Icon, { name: "chevron-left" }),
            " ",
            copy('back')),
        react_1.default.createElement(Header_styled_1.StyledBillingHeading, null,
            react_1.default.createElement(VisualAccessible_1.VisualAccessible, { accessibleLabel: title },
                react_1.default.createElement(IconHeader_1.IconHeader, { icon: "billing", heading: title, subtitle: subtitle })),
            isStatementAvailable ? (react_1.default.createElement(core_1.Feature, { feature: "osv1Download" }, function (enabled) {
                return enabled ? (react_1.default.createElement(DownloadButton_1.DownloadButton, { downloadUrl: billingStatementDownload({
                        accountId: accountId,
                        from: from,
                        to: to,
                    }), handleDownloadClick: function () {
                        (0, handle_bill_download_1.handleDownloadBillClick)(billingStatementDownload({
                            accountId: accountId,
                            from: from,
                            to: to,
                        }), from, to);
                    }, endDate: end })) : (react_1.default.createElement(DownloadButton_1.DownloadButton, { downloadUrl: billingStatementDownload({
                        accountId: accountId,
                        from: from,
                        to: to,
                    }), endDate: end }));
            })) : !isCurrentPeriod ? (react_1.default.createElement(Badge, { "data-testid": "bill-pending", variant: "warning" }, copy('pending'))) : null),
        react_1.default.createElement("div", { "data-testid": "billing-header" }, isCurrentPeriod ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Callout, null,
                react_1.default.createElement(Copy, { copyKey: "currentPeriod", values: {
                        totalCharges: (0, core_1.major2DP)((0, core_1.majorToMinor)(totalCharge)),
                    } })),
            react_1.default.createElement(ProgressBar_1.ProgressBar, { start: start, end: end }))) : !isStatementAvailable ? (react_1.default.createElement(Copy, { copyKey: "chargesPending", values: {
                totalCharges: (0, core_1.major2DP)((0, core_1.majorToMinor)(totalCharge)),
            } })) : null)));
};
exports.Header = Header;
